import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/auth/banner.webp'
import _imports_1 from '../../assets/auth/banner@2x.webp'
import _imports_2 from '../../assets/auth/banner.png'
import _imports_3 from '../../assets/auth/banner@2x.png'
import _imports_4 from '@/assets/auth/banner.png'


const _withScopeId = n => (_pushScopeId("data-v-c89e6652"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x'
const _hoisted_3 = { class: "auth-view fill-height d-flex flex-1 flex-column align-center justify-space-around" }
const _hoisted_4 = {
  class: "auth-view--container d-flex fill-width flex-center pt-12",
  style: {"flex":"1"}
}
const _hoisted_5 = { class: "flex-1 auth-view--form d-flex fill-height pd-2 flex-center" }
const _hoisted_6 = { class: "auth-view--logo" }
const _hoisted_7 = { class: "text--center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "Мы отправили вам письмо, если вы являетесь пользователем системы", -1))
const _hoisted_9 = { class: "text--center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "Пароль успешно изменён", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text--center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "Вход по СберБизнес ID")
], -1))
const _hoisted_12 = { class: "d-none d-md-flex flex-column flex-center auth-view--banner" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_1,
    type: "image/webp"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_2,
    type: "image/png"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "Вход в систему"
  })
], -1))
const _hoisted_14 = {
  key: "auth",
  class: "large"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: "register",
  class: "large"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-view--container fill-width d-flex flex-column-reverse flex-md-row align-md-end pb-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "auth-view--form text--center mt-8" }, [
    /*#__PURE__*/_createTextVNode(" Поддержка: "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@fuelup.ru" }, "support@fuelup.ru")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FuelupLogo = _resolveComponent("FuelupLogo")!
  const _component_AuthByEmail = _resolveComponent("AuthByEmail")!
  const _component_v_stepper_content = _resolveComponent("v-stepper-content")!
  const _component_RestorePassword = _resolveComponent("RestorePassword")!
  const _component_NewPassword = _resolveComponent("NewPassword")!
  const _component_AuthByPhone = _resolveComponent("AuthByPhone")!
  const _component_RegisterByPhone = _resolveComponent("RegisterByPhone")!
  const _component_EnterPinCode = _resolveComponent("EnterPinCode")!
  const _component_svg_ok = _resolveComponent("svg-ok")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_card, {
          ref: "content",
          width: "420",
          class: "auth-card rounded-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FuelupLogo, { class: "logo-scale" })
            ]),
            _createVNode(_component_v_stepper, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_content, { step: "email" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AuthByEmail, {
                      hasSignInError: _ctx.hasSignInError,
                      lastAttempt: _ctx.lastAttempt,
                      tooManyRequest: _ctx.tooManyRequest,
                      temporaryBanned: _ctx.temporaryBanned,
                      restoreDisabled: _ctx.restoreDisabled,
                      "onUpdate:email": _ctx.updateEmail,
                      "onUpdate:password": _ctx.updatePassword,
                      onLoginByPhone: _ctx.gotoPhone,
                      onRegister: _ctx.gotoRegistration,
                      onChangePassword: _ctx.gotoRestore,
                      onSubmit: _ctx.authByEmail
                    }, null, 8, ["hasSignInError", "lastAttempt", "tooManyRequest", "temporaryBanned", "restoreDisabled", "onUpdate:email", "onUpdate:password", "onLoginByPhone", "onRegister", "onChangePassword", "onSubmit"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "restore" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RestorePassword, {
                      hasSignInError: _ctx.hasSignInError,
                      restoreDisabled: _ctx.restoreDisabled,
                      "onUpdate:email": _ctx.updateEmail,
                      onRegister: _ctx.gotoRegistration,
                      onGoToLogin: _ctx.gotoEmail,
                      onLoginByPhone: _ctx.gotoPhone,
                      onSubmit: _ctx.restore
                    }, null, 8, ["hasSignInError", "restoreDisabled", "onUpdate:email", "onRegister", "onGoToLogin", "onLoginByPhone", "onSubmit"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "restore_next_step" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NewPassword, {
                      isPinTimeOver: _ctx.isPinTimeOver,
                      "onUpdate:password": _ctx.updatePassword,
                      onGoToLogin: _ctx.gotoEmail,
                      onSubmit: _ctx.restoreSubmit
                    }, null, 8, ["isPinTimeOver", "onUpdate:password", "onGoToLogin", "onSubmit"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "phone" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AuthByPhone, {
                      isPhoneDisabled: _ctx.phoneDisabled,
                      isTemporaryBanned: _ctx.temporaryBanned,
                      lastAttempt: _ctx.lastAttempt,
                      tooManyRequest: _ctx.tooManyRequest,
                      hasError: _ctx.hasSignInError,
                      "onUpdate:phone": _ctx.updatePhone,
                      onLoginByEmail: _ctx.gotoEmail,
                      onRegister: _ctx.gotoRegistration,
                      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authByPhone(false)))
                    }, null, 8, ["isPhoneDisabled", "isTemporaryBanned", "lastAttempt", "tooManyRequest", "hasError", "onUpdate:phone", "onLoginByEmail", "onRegister"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "registration" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RegisterByPhone, {
                      isPhoneDisabled: _ctx.phoneDisabled,
                      hasSignInError: _ctx.hasSignInError,
                      "onUpdate:phone": _ctx.updatePhone,
                      onGoToLogin: _ctx.gotoEmail,
                      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.authByPhone(true)))
                    }, null, 8, ["isPhoneDisabled", "hasSignInError", "onUpdate:phone", "onGoToLogin"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "pin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EnterPinCode, {
                      hasError: _ctx.hasSignInError,
                      isPinAlive: _ctx.isPinTimeOver,
                      loading: _ctx.progress,
                      tokenPhone: _ctx.tokenPhone,
                      tokenLock: _ctx.tokenPayload?.lock,
                      temporaryBanned: _ctx.temporaryBanned,
                      lastAttempt: _ctx.lastAttempt,
                      onChangePhone: _ctx.gotoPhone,
                      onGoToLogin: _ctx.gotoEmail,
                      "onUpdate:pin": _ctx.updatePin,
                      onRepeatSubmit: _ctx.authByPhone,
                      onSubmit: _ctx.pinSubmit
                    }, null, 8, ["hasError", "isPinAlive", "loading", "tokenPhone", "tokenLock", "temporaryBanned", "lastAttempt", "onChangePhone", "onGoToLogin", "onUpdate:pin", "onRepeatSubmit", "onSubmit"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "restore_sent" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_svg_ok),
                      _hoisted_8,
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "mt-8",
                        onClick: _ctx.gotoEmail
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("На страницу входа")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "restore_success" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_svg_ok),
                      _hoisted_10,
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "mt-8",
                        onClick: _ctx.gotoEmail
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("На страницу входа")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_stepper_content, { step: "sberbizid" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        (_ctx.step === 'registration')
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
              _createTextVNode(" После регистрации водители"),
              _hoisted_15,
              _createTextVNode("смогут заправляться с помощью "),
              _hoisted_16,
              _createTextVNode("виртуальных топливных карт ")
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_17, [
              _createTextVNode(" Контролируйте расходы на топливо "),
              _hoisted_18,
              _createTextVNode(" онлайн в личном кабинете ")
            ]))
      ])
    ]),
    _hoisted_19
  ]))
}